import $ from "jquery";

// IMPORTANT: Don't change to let or const! we are using var intentionally to
// use benefits of hoisting
var Screen = {
    elms: {
        screen: ".screen",
        screenImg: ".screen__img",
        screenInner: ".screen__inner",
        screenFade: ".screen__fade",
    },
    resetCalculation: function () {
        $(this.elms.screenImg).removeAttr("style");
        $(this.elms.screenInner).removeAttr("style");
        $("body")[0].offsetWidth;
    },
    calculateFitSize: function () {
        if (typeof $ === "undefined") return false;
        const isImgExist = $(this.elms.screenImg).length > 0;
        if (!isImgExist) return false;

        this.resetCalculation();

        const $img = $(this.elms.screenImg);
        const $wrapper = $(this.elms.screen);
        const $inner = $(this.elms.screenInner);
        const $fade = $(this.elms.screenFade);
        const imageRatio = $img.height() / $img.width();
        const containerRatio = $wrapper.height() / $wrapper.width();

        let height;
        let width;

        if (containerRatio > imageRatio) {
            // image width is bigger then image height
            width = $wrapper.width();
            height = $wrapper.width() * ($img.height() / $img.width());
        } else {
            // image height is bigger then image width
            height = $wrapper.height();
            width = $wrapper.height() * ($img.width() / $img.height());
        }

        const emUnit = height / 100;
        $inner.css({ height, width, "font-size": emUnit*1.75 });
        $fade.css({ "font-size": emUnit*1.75 });
        $img.css({ height, width });
        return true;
    },

    calculateCoverSize: function () {
        const isImgExist = $(this.elms.screenImg).length > 0;
        if (!isImgExist) return false;

        this.resetCalculation();

        const $img = $(this.elms.screenImg);
        const $wrapper = $(this.elms.screen);
        const $inner = $(this.elms.screenInner);
        const $fade = $(this.elms.screenFade);
        const imageRatio = $img.height() / $img.width();
        const containerRatio = $wrapper.height() / $wrapper.width();

        let height;
        let width;

        if (containerRatio > imageRatio) {
            height = $wrapper.height();
            width = $wrapper.height() / imageRatio;
        } else {
            width = $wrapper.width();
            height = $wrapper.width() * imageRatio;
        }

        const emUnit = height / 100;
        $inner.css({ height, width, "font-size": emUnit*1.75 });
        $fade.css({ "font-size": emUnit*1.75 });
        $img.css({ height, width });
        $wrapper.addClass("is-calculated").trigger("screen-calculated");
        return true;
    },
};

export default Screen;
